import { currentDevUser, getAppUserId } from "../env";

const isDevelopment = process.env.NODE_ENV === "development";

export class AdminService {
  private static current: AdminService;

  public listOfAdmins: number[] = [709420289, 1254124342];

  constructor() {
    if (isDevelopment) {
      this.listOfAdmins.push(currentDevUser);
    }
  }

  /**
   * Является ли текущий пользователь админом?
   */
  public isAdmin() {
    if (isDevelopment) {
      return this.listOfAdmins.includes(currentDevUser);
    }
    return this.listOfAdmins.includes(getAppUserId());
  }

  /**
   * Получить экземляр класса AdminService
   */
  public static getService() {
    if (!this.current) {
      this.current = new AdminService();
    }
    return this.current;
  }
}
